export default __webpack_public_path__ + "static/media/clockIcon.1abaf711.png";